const defaultConfig = {
  controlMinHeight: '44px',
  controlHeight: null,
  borderRadius: '12px',
  borderColor: '#d1d5db',
  borderHoverColor: '#93c5fd',
  controlBackgroundColor: '#ffffff',
  controlPadding: null,
  fontSize: '13px',
  fontWeight: 500,
  valuePadding: '0 10px',
  valueMinHeight: null,
  valueColor: '#1f2937',
  placeholderColor: '#9ca3af',
  optionSelectedBg: '#eff6ff',
  optionBg: '#fff',
  optionHoverBg: '#f3f4f6',
  optionColor: '#1f2937',
  optionFontWeight: 500,
  optionSelectedFontWeight: 600,
  optionPadding: null,
  optionBorderBottom: null,
  indicatorColor: '#6b7280',
  indicatorPadding: '0 6px',
  menuBorderColor: '#dbe3ec',
  menuBorderRadius: '12px',
  menuShadow: '0 10px 28px rgba(0,0,0,0.08)',
  menuBg: '#fff',
  menuZIndex: 9999,
};

export const getSelectMenuPortalTarget = () =>
  typeof document !== 'undefined' ? document.body : null;

export const createReactSelectStyles = (config = {}) => {
  const tokens = { ...defaultConfig, ...config };

  return {
    container: (provided) => ({
      ...provided,
      width: '100%',
      minWidth: 0,
    }),
    control: (provided) => ({
      ...provided,
      display: 'flex',
      position: 'relative',
      alignItems: 'center',
      flexWrap: 'nowrap',
      minHeight: tokens.controlMinHeight,
      ...(tokens.controlHeight ? { height: tokens.controlHeight } : {}),
      borderRadius: tokens.borderRadius,
      boxShadow: 'none',
      borderColor: tokens.borderColor,
      backgroundColor: tokens.controlBackgroundColor,
      minWidth: 0,
      fontSize: tokens.fontSize,
      fontWeight: tokens.fontWeight,
      ...(tokens.controlPadding ? { padding: tokens.controlPadding } : {}),
      '&:hover': {
        borderColor: tokens.borderHoverColor,
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      padding: tokens.valuePadding,
      ...(tokens.valueMinHeight ? { minHeight: tokens.valueMinHeight } : {}),
      minWidth: 0,
      overflow: 'hidden',
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: 0,
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: tokens.valueColor,
      fontSize: tokens.fontSize,
      fontWeight: tokens.fontWeight,
    }),
    placeholder: (provided) => ({
      ...provided,
      margin: 0,
      color: tokens.placeholderColor,
      fontSize: tokens.fontSize,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      flexShrink: 0,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      lineHeight: 0,
      color: tokens.indicatorColor,
      padding: tokens.indicatorPadding,
      paddingTop: 0,
      paddingBottom: 0,
      flexShrink: 0,
      '& > svg': {
        display: 'block',
      },
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? tokens.optionSelectedBg : tokens.optionBg,
      color: tokens.optionColor,
      fontSize: tokens.fontSize,
      fontWeight: state.isSelected ? tokens.optionSelectedFontWeight : tokens.optionFontWeight,
      cursor: 'pointer',
      ...(tokens.optionPadding ? { padding: tokens.optionPadding } : {}),
      ...(tokens.optionBorderBottom ? { borderBottom: tokens.optionBorderBottom } : {}),
      '&:hover': {
        backgroundColor: tokens.optionHoverBg,
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: tokens.menuBorderRadius,
      border: `1px solid ${tokens.menuBorderColor}`,
      boxShadow: tokens.menuShadow,
      overflow: 'hidden',
      backgroundColor: tokens.menuBg,
      zIndex: tokens.menuZIndex,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: tokens.menuZIndex,
    }),
    indicatorSeparator: () => null,
  };
};
